import React, { Component } from 'react';
import DatePicker from 'material-ui/DatePicker';
import areIntlLocalesSupported from 'intl-locales-supported';

let DateTimeFormat;

/**
 * Use the native Intl.DateTimeFormat if available, or a polyfill if not.
 */
if (areIntlLocalesSupported(['es', 'fa-IR'])) {
  DateTimeFormat = global.Intl.DateTimeFormat;
} else {
  const IntlPolyfill = require('intl');
  DateTimeFormat = IntlPolyfill.DateTimeFormat;
  require('intl/locale-data/jsonp/es');
  require('intl/locale-data/jsonp/fa-IR');
}

// We can inject some CSS into the DOM.
const Props = (title) => ({
  //background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
  autoOk: true,
  fullWidth: true,
  underlineShow: false,
  floatingLabelText: title,
  style: {
    fontSize: 16,
    fontWeight: 500,
    height: 70,
    padding: '0px 10px',
    boxShadow: '0px 0px 2px 2px transparent',
  },
  floatingLabelShrinkStyle: {
    fontSize: 18
  },
  floatingLabelFocusStyle: {
    color: '#a0cef8',
    fontWeight: 500
  },
  floatingLabelStyle: {
    fontWeight: 400
  },
  underlineStyle: {
    margin: '-0px 0px -10px -10px'
  }
})

const PropsError = (result) =>  { //name, title, value

  //const result = FilterNames(name, title, value)

  const propsError = (result.isError) ? {
    floatingLabelText: result.message,
    style: {
      ...Props().style,
      //margin: '0px -1px 1px 0px',
      //border: '1px solid red'

      //boxShadow: '0px 0px 2px 2px rgba(255, 0, 0, 0.5)',
    },
    floatingLabelStyle: {
      ...Props().floatingLabelStyle,
      color: 'red'
    },
    floatingLabelFocusStyle: {
      ...Props().floatingLabelFocusStyle,
      color: 'red'
    },
  } : { }
  return ({...propsError})
};

const GetError = (errors, name) => {
  let result = {isError: false}
  if (errors !== undefined){
    if (errors[name] !==undefined){
      result = errors[name]
    }
  }
  return (result)
}

class inputDate extends Component {
  render() {
    const {title, name, value, onChange, section, errors } = this.props
    const id = section + name
    const devaultValue = (name !== undefined && value !== undefined)? {value: value[name]}: {}

    const props = {...devaultValue, ...Props(title), ...PropsError(GetError(errors, id))}

    return (
      <div className='input-text'>
        <div className='input-text-container'>
          <DatePicker id={id}
            DateTimeFormat={DateTimeFormat} locale="es"
            {...props} onChange={(evt, date) => onChange(name, date, title, id)}
            openToYearSelection={this.props.openToYearSelection || false}/>
        </div>
      </div>
    )
  }
}

export default inputDate



// WEBPACK FOOTER //
// ./src/shared/routes/components/inputDate.js